// Uploader.jsx

import React, { useRef } from "react";
import placeholderImage from "../../../assets/placeholder-image.png";
import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

export default function Uploader({
  value,
  onChange,
  onRemove, // new prop!
  placeholder = placeholderImage,
  label = "",
  style = {},
  disabled = false,
  size = 120,
}) {
  const inputRef = useRef();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        ...style,
      }}
    >
      {label && (
        <p style={{ fontSize: 14, fontWeight: 500, color: "#888", marginBottom: 6 }}>{label}</p>
      )}
      <div
        className="placeholderIMG"
        style={{
          width: size,
          height: size,
          borderRadius: 12,
          border: "1px dashed #ccc",
          overflow: "hidden",
          cursor: disabled ? "not-allowed" : "pointer",
          background: "#f4f4f4",
          marginBottom: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
        onClick={() => !disabled && inputRef.current && inputRef.current.click()}
      >
        <img
          src={value
            ? typeof value === "string"
              ? value
              : URL.createObjectURL(value)
            : placeholder}
          alt="upload"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
        {/* Remove Button */}
        {value && onRemove && (
          <IconButton
            size="small"
            onClick={e => {
              e.stopPropagation();
              onRemove();
            }}
            sx={{
              position: "absolute",
              top: 2,
              right: 2,
              bgcolor: "#fff8",
              "&:hover": { bgcolor: "#fff" },
              zIndex: 2
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        style={{ display: "none" }}
        onChange={e => {
          if (e.target.files && e.target.files[0]) {
            onChange(e.target.files[0]);
          }
        }}
        disabled={disabled}
      />
    </div>
  );
}